import { UserCustomFilter } from 'core/utils/types/user-custom-filter.type';
import { t } from 'core/i18n/i18n';
import { CustomFieldFilterCriteria } from '../pods/private-pods/operators-list/operators-filter/types/search-filter-criteria.type';
import { DEACTIVATE_FILTER_PARAM } from 'commons/hooks/create-filter-context';

export type OperatorsFilterFields = {
    active?: boolean;
    locationsLevel1?: string[];
    locationsLevel2?: string[];
    trainingStages?: string[];
    nameBadgeid?: string[];
    alarmType?: string[];
    customFields?: CustomFieldFilterCriteria[];
};

export type AlarmTypesFilter = {
    noAlarms: boolean;
    status: string[];
};

export type LocationsFilter = {
    noLocations: boolean;
    locations: string[];
};

export type TrainingStagesFilter = {
    noTrainingStages: boolean;
    trainingStages: string[];
};

export const NO_TRAININGS = 'NO_TRAININGS';

export const isEmptyFilter = (filter: UserCustomFilter<OperatorsFilterFields>): boolean =>
    !filter.fields.alarmType?.length &&
    !filter.fields.locationsLevel1?.length &&
    !filter.fields.locationsLevel2?.length &&
    !filter.fields.trainingStages?.length &&
    !filter.fields.nameBadgeid?.length &&
    !filter.fields.customFields?.length;

export const isOperatorFilterActive = (filter?: UserCustomFilter<OperatorsFilterFields>): boolean =>
    !!filter && !isEmptyFilter(filter);

export const isEmptySorting = (filter: UserCustomFilter<OperatorsFilterFields>): boolean =>
    !filter.sorting || Object.keys(filter.sorting).length === 0;

export const defaultFilters: {
    active: UserCustomFilter<OperatorsFilterFields>;
    inactive: UserCustomFilter<OperatorsFilterFields>;
} = {
    active: {
        name: t('modules.operators.pods.operators-list.table.title.active'),
        fields: {
            active: true,
            alarmType: [],
            locationsLevel1: [],
            locationsLevel2: [],
            trainingStages: [],
            nameBadgeid: [],
            customFields: [],
        },
        sorting: {},
    },
    inactive: {
        id: DEACTIVATE_FILTER_PARAM,
        name: t('modules.operators.pods.operators-list.table.title.inactive'),
        fields: {
            active: false,
            alarmType: [],
            locationsLevel1: [],
            locationsLevel2: [],
            trainingStages: [],
            nameBadgeid: [],
            customFields: [],
        },
        sorting: {},
    },
};
